<template>
  <div class="hobaoImport">
      <div v-if="bigShow" class="bigHobaoImportBox">
        <div class="bigHobaoImportImg">
            <img src="../assets/btn_newyear_big.png" style="cursor: pointer;" alt="" @click="toHongbao">
            <span @click="closeBig"><img style="cursor: pointer;" src="../assets/icon_close_hb.png" alt=""></span>
            <div class="remember">
                <label for="hbcom"><input type="checkbox" id="hbcom" v-model="checked" @change="changeCom"><span>不再提示</span></label>
            </div>
        </div>
        
      </div>
      <div v-if="!bigShow && smallShow" class="smallHobaoImportBox">
          <img src="../assets/btn_newyear_small.png" alt="" @click="toHongbao">
          <span @click="closeSmall"><img src="../assets/icon_close_hb.png" alt=""></span>
      </div>
  </div>
</template>

<script>
export default {
    components:{

    },
    data(){
        return {
            checked:'',
            smallShow:false
        }
    },
    computed:{
        bigShow(){
            return this.$store.state.hbImportShow
        },
    },
    methods:{
        changeCom(){
            localStorage.showHbImport = this.checked?1:0
        },
        toHongbao(){
            if (process.env.NODE_ENV == "development") {
            location.href = "https://www.guigui.com.cn/hongbao.html";
            } else {
                location.href = "./hongbao.html";
            }
        },
        closeBig(){
            this.$store.commit('sethbImportShow',false)
            this.smallShow = true
        },
        closeSmall(){
            this.smallShow = false
        }
    },
}
</script>

<style lang='less'>
    .hobaoImport{
        .bigHobaoImportBox{
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 2000;
            background: rgba(75, 75, 75, 0.5);
            .bigHobaoImportImg{
                position: relative;
                top: 50%;
                width: 600px;
                margin: 0 auto;
                transform: translateY(-50%);
                height: auto;
                .remember{
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    color: #e0e0e0;
                    label{
                        display: flex;
                        align-items: center;
                    }
                    input{
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }
                    span{
                        color: #000;
                        font-size: 16px;
                        cursor: pointer;
                    }
                }
                >img{
                    width: 100%;
                }
                >span{
                    position: absolute;
                    top: -18px;
                    right: 0;
                    display: inline-block;
                    width: 50px;
                    height: 50px;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
            }
        }
        .smallHobaoImportBox{
            position: fixed;
            bottom: 60px;
            right: 8px;
            cursor: pointer;
            z-index: 2000;
            >span{
                position: absolute;
                top: -18px;
                right: -1px;
                display: inline-block;
                width: 24px;
                height: 24px;
                overflow: hidden;
                cursor: pointer;
                >img{
                    width: 100%;
                }
            }
        }
    }
</style>